import React, { useState } from 'react';
import { Form, Col, Row, Input } from 'antd';
import ConfirmationModal from '../ConfirmationModal';
import styles from './DeleteConfirmationModal.module.less';

type DeleteConfirmationModalProps = {
  visible: boolean;
  itemName: string;
  placeholder?: string;
  onClose: () => void;
  onConfirm: () => void;
};

const OK_STRING = 'delete';

const inputLabel = (
  <>
    To confirm deletion, type <i>{OK_STRING}</i> in the text field.
  </>
);

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  visible,
  itemName,
  placeholder = OK_STRING,
  onClose,
  onConfirm,
}) => {
  const [disabled, setDisabled] = useState<boolean>(true);

  const handleClose = () => {
    setDisabled(true);
    onClose();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setDisabled(value.trim().toLowerCase() !== OK_STRING);
  };

  return (
    <ConfirmationModal
      visible={visible}
      confirmText="Delete"
      confirmDisabled={disabled}
      className={styles.container}
      destroyOnClose={true}
      onClose={handleClose}
      onConfirm={onConfirm}
    >
      <h1 className={styles.title}>
        Are you sure you want to delete <span>{itemName}</span>?
      </h1>

      <Form layout="vertical" className={styles.form}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item label={inputLabel}>
              <Input type="text" placeholder={placeholder} onChange={handleChange} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </ConfirmationModal>
  );
};

export default DeleteConfirmationModal;
